import VolumeOffIcon from "@material-ui/icons/VolumeOff";
import VolumeMuteIcon from "@material-ui/icons/VolumeMute";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "@material-ui/core";

import { ReduxState } from "../../types/redux.types";
import { muteNotification } from "./reducer";

export const MuteNotifications = () => {
  const dispatch = useDispatch();
  const muted = useSelector<ReduxState, boolean>((state) => state.notifications.muted);

  const handleMuteNotification = () => {
    dispatch(muteNotification(!muted));
  };

  return (
    <>
      {muted ? (
        <IconButton onClick={handleMuteNotification}>
          <VolumeOffIcon style={{ color: "white" }} />
        </IconButton>
      ) : (
        <IconButton onClick={handleMuteNotification}>
          <VolumeMuteIcon style={{ color: "white" }} />
        </IconButton>
      )}
    </>
  );
};
